import { fetchWrapper } from "@helpers/fetchwrapper";

export function fetchCareerGuidanceByHolland(
  hollandApi,
  { offset = 0, limit = 50, oksoCode = "", type } = {}
) {
  const params = new URLSearchParams({
    Offset: String(offset),
    Limit: String(limit),
  });

  Object.entries(hollandApi || {}).forEach(([key, value]) => {
    if (value != null && Number(value) > 0) {
      params.set(key, String(value));
    }
  });

  if (oksoCode) {
    params.set("OksoCode", oksoCode);
  }

  if (type != null) {
    params.set("Type", String(type));
  }

  return fetchWrapper.get(
    `/v1/api/app/FindCareerGuidanceByHolland?${params.toString()}`
  );
}

export function fetchCompaniesWithFaculty({
  text = "",
  types = [2, 3],
  limit = 10,
  offset = 0,
  faculty = [],
} = {}) {
  const data = { text, types, limit, offset };

  if (faculty.length > 0) {
    data.faculty = faculty;
  }

  return fetchWrapper.post("/v1/api/app/findCompaniesWithFaculty", data);
}

export function fetchCompaniesWithFacultyByCodes({
  text = "",
  types = [2, 3],
  limit = 10,
  offset = 0, 
  faculty = [],
} = {}) {
  const data = { text, types, limit, offset };

  if (faculty.length > 0) {
    data.faculty = faculty;
  }

  return fetchWrapper.post(
    "/v1/api/app/FindCompaniesWithFacultyByCodes",
    data
  );
}

export function fetchCompaniesWithSpecialistNeeds({
  text = "",
  limit = 100,
  offset = 0,
} = {}) {
  return fetchWrapper.post(
    "/v1/api/app/FindCompaniesWithPracticesAndMentorshipsAndSpecialistNeeds",
    {
      text,
      limit,
      offset,
      CoordinateSize: 3,
    }
  );
}

export function fetchCompaniesBySpecialistNeeds({
  specIds = [],
  limit = 100,
  offset = 0,
  coordinateSize = 3,
} = {}) {
  return fetchWrapper.post("/v1/api/app/FindCompaniesBySpecialistNeeds", {
    SpecIds: specIds,
    Limit: limit,
    Offset: offset,
    CoordinateSize: coordinateSize,
  });
}

export function extractSpecialistNeedIds(items) {
  const ids = new Set();

  (items || []).forEach((item) => {
    if (item.SpecialistNeedsItemId != null) {
      ids.add(Number(item.SpecialistNeedsItemId));
    }
  });

  return [...ids];
}

export function buildCareerSearchText(items, limit = 5) {
  const titles = [];

  (items || []).forEach((item) => {
    [item.OksoTitle, item.OkzTitle, item.SpecialistNeedsItem]
      .filter(Boolean)
      .forEach((title) => {
        const normalized = title.trim();
        if (normalized && !titles.includes(normalized)) {
          titles.push(normalized);
        }
      });
  });

  return titles.slice(0, limit).join(" ");
}

/**
 * Сохраняет результат прохождения профтеста (опросник Холланда) на сервере.
 *
 * На сервер отправляются:
 *  - код Холланда (hollandCode) и упорядоченный список типов (sortedTypes);
 *  - баллы по каждому типу (scores.total);
 *  - нормализованные значения для подбора (hollandApi);
 *  - дата и время прохождения (completedAt, ISO-8601);
 *  - версия опросника (version) и исходные ответы (answers).
 *
 * IP-адрес пользователя определяется на стороне сервера
 * (X-Forwarded-For / X-Real-IP / req.socket.remoteAddress).
 *
 * @param {object} hollandData - результат, полученный из buildHollandPairResultPayload.
 * @returns {Promise<object>} ответ сервера с сохранённой записью.
 */
export function saveHollandResultToServer(hollandData) {
  return fetchWrapper.post("/v1/api/app/SaveHollandResult", hollandData);
}

